export default "__VITE_ASSET__HehUWr5G__"